import {
  Breadcrumb,
  Row,
  Col,
  Button,
} from "antd";
import "../../accountList/AccountListPage.css"

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { modalConfirmCancel, modalCustom } from "../../modal/modalCustom";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { SIDEBAR_CONSTANT } from "../../../constant/sidebar.constant";
import { RESOURCE_LIST_CONSTANT } from "../../../constant/resourcelist.constant";
import resourceListService from "../../../service/resourceListService";
import moment from "moment";
import { last } from "lodash";
import { ROUTER_CONSTANT } from "../../../constant/router.constant";

const ResourceListDetailForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state) => state.loginData.token);
  const baseUrl = ROUTER_CONSTANT.HOME + ROUTER_CONSTANT.RESOURCE_LIST;
  const [dataResourceListDetail, setDataResourceListDetail] = useState({
    resource_list_id: null,
    resource_id: null,
    resource_name: null,
    description: null,
    logo: null,
    created_by: null,
    created_client: null,
    created_at: null,
    updated_by: null,
    updated_client: null,
    updated_at: null,
    deleted: null,
  });
  const [locationPath, setLocationPath] = useState(null);

  const okFunction = () => {
    navigate(`${baseUrl}`);
  }

  const failedFunction = () => {
    // TODO : Keep It for future use, click button after pop up failed modal
  }

  const modalConfirmDelete = () => {
    modalConfirmCancel(
      RESOURCE_LIST_CONSTANT.MODAL_DELETE_TITLE,
      RESOURCE_LIST_CONSTANT.MODAL_DELETE_CONTENT,
      RESOURCE_LIST_CONSTANT.MODAL_DELETE_OK_TEXT,
      RESOURCE_LIST_CONSTANT.MODAL_DELETE_NO_TEXT,
      handleDelete
    );
  }

  const handleDelete = () => {
    let params = {
      ResourceListID: dataResourceListDetail.resource_list_id
    };
    resourceListService.deleteResource(token, params)
      .then((response) => {
        if (response.data.nexsoft.payload.status.success) {
          modalDeleteSuccess();
        } else {
          modalDeleteFailedWithMessage(response.data.nexsoft.payload.status.message);
        }
      }).catch((error) => {
        modalDeleteFailed();
      })
  }

  const modalDeleteSuccess = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_CONTENT_DELETE_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_SUCCESS_OK_BUTTON_ADD_RESOURCES,
      okFunction,
      "success"
    );
  }

  const modalDeleteFailed = () => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_CONTENT_DELETE_RESOURCES,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    );
  }

  const modalDeleteFailedWithMessage = (failedMessage) => {
    modalCustom(
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_TITLE_ADD_RESOURCES,
      failedMessage,
      RESOURCE_LIST_CONSTANT.MODAL_FAILED_OK_BUTTON_ADD_RESOURCES,
      failedFunction,
      "failed"
    );
  }

  const chooseTitleByLocationPath = () => {
    let titlePage = RESOURCE_LIST_CONSTANT.TITLE_RESOURCE_LIST_DETAIL;
    if (locationPath === "delete") {
      titlePage = RESOURCE_LIST_CONSTANT.TITLE_RESOURCE_LIST_DELETE;
    }

    return titlePage;
  }

  useEffect(() => {
    if (!location.state) {
      navigate(baseUrl);
    }

    if (location.state) {
      const data = location.state;
      setDataResourceListDetail({
        resource_list_id: data.resource_list_id,
        resource_id: data.resource_id,
        resource_name: data.resource_name,
        description: data.description,
        logo: data.logo,
        created_by: data.created_by,
        created_client: data.created_client,
        created_at: data.created_at,
        updated_by: data.updated_by,
        updated_client: data.updated_client,
        updated_at: data.updated_at,
        deleted: data.deleted,
      });
      setLocationPath(last(location.pathname.split("/")));
    }

  }, [location.state, navigate, location.pathname, baseUrl]);

  return (
    <>
      <Row>
        <Breadcrumb separator=">">
          <Breadcrumb.Item>{SIDEBAR_CONSTANT.MENU_SETTING_LIST}</Breadcrumb.Item>
          <Breadcrumb.Item
            onClick={() => okFunction()}
            style={{ cursor: "pointer" }}
          >
            {RESOURCE_LIST_CONSTANT.MENU_RESOURCE_LIST}
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {chooseTitleByLocationPath()}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>

      <Row className="accountlist-title">
        <MdOutlineArrowBackIosNew
          onClick={() => okFunction()}
          className="arrow-back-form-title"
        />
        {chooseTitleByLocationPath()}
      </Row>

      <br />

      <Row className="card-white-box-container">
        <Col xs={24} md={24}>
          <div className="card-white-box">
            <Row justify="space-between">

              <Col xs={24} md={12}>
                <Row className="form-label-title">
                  Resource List ID
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.resource_list_id}
                </Row>

                <Row className="form-label-title">
                  Resource ID
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.resource_id}
                </Row>

                <Row className="form-label-title">
                  Resource Name
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.resource_name}
                </Row>

                <Row className="form-label-title">
                  Description
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.description ? dataResourceListDetail.description : "-"}
                </Row>

                <Row className="form-label-title">
                  Upload Logo
                </Row>
                <Row className="form-label-content">
                  <img alt="Upload Logo" className="add-resource-logo-list-style" src={dataResourceListDetail.logo} />
                </Row>

                <Row className="form-label-title">
                  Created By
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.created_by}
                </Row>
              </Col>

              <Col xs={24} md={12}>
                <Row className="form-label-title">
                  Created Client
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.created_client}
                </Row>

                <Row className="form-label-title">
                  Created At
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.created_at && moment.utc(dataResourceListDetail.created_at).format("YYYY-MM-DD HH:mm:ss")}
                </Row>

                <Row className="form-label-title">
                  Updated By
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.updated_by}
                </Row>

                <Row className="form-label-title">
                  Updated Client
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.updated_client}
                </Row>

                <Row className="form-label-title">
                  Updated At
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.updated_at && moment.utc(dataResourceListDetail.updated_at).format("YYYY-MM-DD HH:mm:ss")}
                </Row>

                <Row className="form-label-title">
                  Deleted
                </Row>
                <Row className="form-label-content">
                  {dataResourceListDetail.deleted}
                </Row>
              </Col>

            </Row>
          </div>
        </Col>
      </Row>

      <Row justify="end">
        <Col>
          <Button className="form-button-footer-style" key="cancel"
            onClick={() => okFunction()}
          >
            Cancel
          </Button>
        </Col>
        {
          locationPath === "delete" &&
          <>
            <Col>
              <Button className="form-button-footer-style" key="save"
                onClick={() => modalConfirmDelete()}
                type="delete-button">
                Delete
              </Button>
            </Col>
          </>
        }
      </Row>
      <br />
    </>
  )
}

export default ResourceListDetailForm;